import { getDefaultUserState } from '../auth/index';
import authStoreMutations from '@constans/store/auth/authStoreMutations';
const mutations = {
    [authStoreMutations.SET_AUTH]: (state, auth) => state = Object.assign(state, auth),
    [authStoreMutations.CLEAR_AUTH]: (state) => Object.assign(state, getDefaultUserState()),
    [authStoreMutations.SET_LOGIN_ERR_MSG]: (state, msg) => state.login_err_msg = msg
};
export default mutations;
